var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgeLogoAnim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.81 66.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "forge-logo-anim-linear-gradient",
    x1: 20.06,
    y1: 0,
    x2: 20.06,
    y2: 59.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#ffae00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#ffae00;#ffc400;#ffae00;#ff9500;#ffae00",
    dur: "10s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ff4d00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#ff4d00;#ff6b00;#ff8500;#ff4d00;#ff3300;#ff4d00",
    dur: "12s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "translate",
    values: "0,0; 0.5,-1; -0.25,0.5; 0.4,-0.75; 0,0",
    dur: "15s",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "anvil-elem",
    d: "M13.5,47.17c6.37.85,1.79,9.09,4.47,12.5.84,1.07,2.5,1.28,3.72.78,3.84-1.57.62-8.97,2.65-11.73.47-.64,1.82-1.55,2.62-1.55h13.6c.15,0,.27.14.24.29-1,5.39-7.64,5.78-11.49,8.39-3.53,2.4-2.84,5.83,1.03,7.28.37.14,1.34.46,1.74.59.1.03.17.13.16.24l-.1,2.2c0,.13-.11.23-.24.23H9.12c-.13,0-.23-.1-.24-.22l-.17-2.15c0-.11.05-.21.15-.24.34-.13,1.09-.42,1.38-.54,2.14-.89,4.44-2.95,3.34-5.49-1.03-2.39-5.92-3.88-8.18-5.12-2.01-1.1-4.25-2.77-5.37-4.87-.14-.26.11-.57.4-.57h13.06Z",
    style: {
      fill: "#474c53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "flame-elem",
    d: "M30.66,16.25h0s-13.87,0-13.87,0c0,0,.03,0,0,0-2.46.06-2.28,2.69-2.28,3.58,0,.1,0,0,0,0v20.26s0,.51,0,.76c0,1.35,5.42,1.32,5.42,0,0-.03,0-.04,0-.04v-7.9s0,.03,0,0c0-.36.2-.59.52-.59.02,0,0,0,0,0h7.61s-.02,0,0,0c.94,0,1.61-1.52,1.84-2.36.18-.66.67-2.98-.06-3.22,0,0-2.78.05-9.41,0-.17,0-.47-.09-.48-.41,0-.37,0-3.02,0-3.7,0-.73,0-.88.53-.88h14.66c4.7,7.54,3.48,17.24-4.45,21.89-2.64,1.55-6.46,2.02-7.99,4.77-1.39,2.5-.22,6.37-.68,9.13-.33,2.01-3,1.91-3.29.13-.66-3.98,1.6-9.08-2.98-11.54-4.31-2.32-7.38-2.16-10.67-6.66-7.86-10.76,2.68-22.86,8.94-31.35,2-2.72,3.97-5.5,6.17-8.06.13-.15.37-.09.41.1.2.93.66,3.02,1.07,3.9.93,2,2.21,3.91,3.74,5.91,1.71,2.15,3.72,3.98,5.27,6.26Z",
    style: {
      fill: "url(#forge-logo-anim-linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "slot-elem",
    d: "m27 47.17v15h-13v-15z",
    style: {
      fill: "#474c53"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgeLogoAnim);
export default __webpack_public_path__ + "static/media/forge-logo-anim.baf19728ab26d8eaededab7b50236c41.svg";
export { ForwardRef as ReactComponent };